import apiClient from "./axiosClient"

/**
 * 
 * @param {Object} data 
 * @return request
 */
const createAuthor = (data) => {
  return apiClient.post(`/authors/`,  data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}

/**
 * 
 * @param {id} data 
 * @return request
 */
const getAuthor = (id) => {
  return apiClient.get(`/authors/${id}`);
}

/**
 * 
 * @param {id} data 
 * @return request
 */
const getRandomAuthors = (limit, offset) => {
  return apiClient.get(`/authors/random?limit=${limit}&offset=${offset-1}`);
}

/**
 * 
 * @param {id} data 
 * @return request
 */
const searchAuthor = (letters) => {
  return apiClient.get(`/authors/${letters}/search/`);
}

/**
 * Executes the request to get the books that have 'text' in the title.
 * @param {string} text 
 * @returns Promise
 */
const searchAuthorByText = (text) => {
  return apiClient.get(`/authors/${text}/search`);
}

/**
 * 
 * @param {Object} data 
 * @return request
 */
const updateAuthor = (id, data) => {
  return apiClient.put(`/authors/${id}`, data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}

/**
 * 
 * @param {id} data 
 * @return request
 */
const deleteAuthor = (id) => {
  return apiClient.delete(`/authors/${id}`);
}

export {
  createAuthor, getAuthor, getRandomAuthors, 
  searchAuthor, updateAuthor, deleteAuthor, searchAuthorByText
};




